import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { actions } from 'react-table';
const initialState = {
  generalSettings: null,
  ingestionLayer: [{
    sourceData: [],
    activatedSources: [],
  },
  {
    targetData: [],
    activatedTarget: [],
  },
  {
    pipeplineData: [],
    activatedPipeline: [],
    runningPipeline: '',
  },],
  // dataLakeSetup: [{
  //   Bronze: [{ title: "Bronze", key: 1, position: 0 },
  //   { title: "YYYY", key: 2, position: 1 },
  //   { title: "MM", key: 3, position: 2 },
  //   { title: "DD", key: 4, position: 3 },
  //   { title: "File Name", key: 5, position: 4 },]
  // },
  // {
  //   Silver: [{ title: "Silver", key: 1, position: 0 },
  //   { title: "Cleansed", key: 2, position: 1 }]
  // },
 
  // { Gold: [{ title: "Gold", key: 1, position: 0 }] },
  // { Exception: [{ title: "Exception", key: 1, position: 0 }] },
  // { Archive: [{ title: "Archive", key: 1, position: 0 }] },
  // ],
  dataLakeSetup: [{
    Bronze: [{ 
      title: "New Node", 
      key: 1, 
      positionX: 0, 
      positionY: 0, 
      parentKey: null 
    }]
  }],
  isResetDisabled:false,
  DataqualityPipelin: {
    generalsetting: {},
    selectedTable: null,
    filters: [],
    fill_null_values: {},
    Standardization: {},
    expression: [],
    sourceTargetMapping: {
      targetable: null,
      targetLayer: null,
      targetcolumns: [],
      mappings: [],
    },
    sourceTables: {
      Datalakes_tables: [
        { dataLake: null, table: null, tableOptions: [], columnOptions: [] }
      ],
      relation: null,
      bothcolumns: [{ table1Column: null, condition: null, table2Column: null }]
    },
    joinedColumns: [],
  },
  dataModal: {
    mermaidScript: '',
    schemaData:[],
    rawData:[],
    dataModalData:[],
    selectedSchema:null,
    renderdataModel:false,
    ErView:false,
    isModifying:false,
  },
  pipelineTab: null,
  dataModelTable: {},
  dataModelConfiguration: {
    mermaidScript: '',
    table: null,
  },
};
 
const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    ADDGeneralSetting(state, action) {
      state.generalSettings = action.payload;
    },
    setProject(state: any, action) {
      state.generalSettings =  action.payload;
    },
    GETSourceData(state: any, action) {
      state.ingestionLayer = state.ingestionLayer?.map((layer: any, index: any) =>
        index === 0 ? { ...layer, sourceData: action.payload } : layer
      );
    },
    storeActivatedSource(state: any, action) {
      state.ingestionLayer = state.ingestionLayer?.map((layer: any, index: any) =>
        index === 0 ? { ...layer, activatedSources: action.payload } : layer
      );
    },
    GETTargetData(state: any, action) {
      state.ingestionLayer = state.ingestionLayer?.map((layer: any, index: any) =>
        index === 1 ? { ...layer, targetData: action.payload } : layer
      );
    },
    storeActivatedTarget(state: any, action) {
      state.ingestionLayer = state.ingestionLayer?.map((layer: any, index: any) =>
        index === 1 ? { ...layer, activatedTarget: action.payload } : layer
      );
    },
    getRunningPipeline(state : any, action : PayloadAction<any>) {
      state.ingestionLayer = state.ingestionLayer?.map((layer: any, index: any) =>
        index === 2 ? { ...layer, runningPipeline: action.payload } : layer
      );
    },
    // setDataLakeSetup(state, action) {
    //   state.dataLakeSetup = action.payload || state.dataLakeSetup;
    // },
    setDataLakeSetup(state, action) {
      state.dataLakeSetup = action.payload || state.dataLakeSetup;
    },
    setResetDisabled(state, action) {
      state.isResetDisabled = action.payload;
    },
    resetDataLake(state) {
      state.dataLakeSetup = initialState.dataLakeSetup;
    },
    // setResetDisabled(state, action) {
    //   state.isResetDisabled = action.payload;
    // },
    createNewPipelinetransformation(state) {
      state.DataqualityPipelin = initialState.DataqualityPipelin;
    },
    setDeDuplication(state: any, action) {
      state.deDuplication = action.payload;
    },
    setPipelineTab(state, action) {
      state.pipelineTab = action.payload;
    },
    setPipelineTable(state, action) {
      state.DataqualityPipelin.selectedTable = action.payload;
    },
    addGeneralSettingsDQ(state, action) {
      state.DataqualityPipelin.generalsetting = action.payload;
    },
    updateFilters(state, action) {
      state.DataqualityPipelin.filters = action.payload;
    },
    updateFillNullvalues(state, action) {
      state.DataqualityPipelin.fill_null_values = action.payload;
    },
    updateStandardization(state, action) {
      state.DataqualityPipelin.Standardization = action.payload;
    },
    updateSourceTables(state: any, action) {
      state.DataqualityPipelin.sourceTables.sourceTables = action.payload;
    },
    updateDatalakeTables(state: any, action) {
      const { index, field, value } = action.payload;
 
      // Check if the index exists in the Datalakes_tables array
      if (state.DataqualityPipelin.sourceTables.Datalakes_tables[index]) {
        // Update the field if the index is valid
        state.DataqualityPipelin.sourceTables.Datalakes_tables[index][field] = value;
      } else {
        // If the index doesn't exist, create a new object with default values
        state.DataqualityPipelin.sourceTables.Datalakes_tables[index] = {
          dataLake: null,
          table: null,
          tableOptions: [],
          columnOptions: [],
          [field]: value,
        };
      }
    },
 
    updateRelation(state, action) {
      state.DataqualityPipelin.sourceTables.relation = action.payload;
    },
    updateBothColumns(state: any, action) {
      const { index, field, value } = action.payload;
      state.DataqualityPipelin.sourceTables.bothcolumns[index][field] = value;
    },
    updateTableOptions(state: any, action) {
      state.DataqualityPipelin.sourceTables.Datalakes_tables[action.payload.index].tableOptions = action.payload.options;
    },
    updateColumnOptions(state: any, action: { payload: { index: number; options: any } }) {
      state.DataqualityPipelin.sourceTables.Datalakes_tables[action.payload.index].columnOptions = action.payload.options;
    },
 
    updateJoinedColumns(state, action) {
      state.DataqualityPipelin.joinedColumns = action.payload;
    },
    addJoinedColumn(state: any, action) {
      state.DataqualityPipelin.joinedColumns.push(action.payload);
    },
    updateExpression(state: any, action) {
      state.DataqualityPipelin.expression.push(action.payload);
    },
    setExpression(state, action) {
      state.DataqualityPipelin.expression = action.payload;
    },
    updateDataQualityPipeline(state, action) {
      const { generalsetting, selectedTable, joinedColumns, filters, fill_null_values, Standardization, expression, sourceTargetMapping, sourceTables } = action.payload;
      state.DataqualityPipelin = {
        ...state.DataqualityPipelin,
        generalsetting: generalsetting || state.DataqualityPipelin.generalsetting,
        selectedTable: selectedTable || state.DataqualityPipelin.selectedTable,
        joinedColumns: joinedColumns || state.DataqualityPipelin.joinedColumns,
        filters: filters || state.DataqualityPipelin.filters,
        fill_null_values: fill_null_values || state.DataqualityPipelin.fill_null_values,
        Standardization: Standardization || state.DataqualityPipelin.Standardization,
        expression: expression || state.DataqualityPipelin.expression,
        sourceTargetMapping: {
          ...state.DataqualityPipelin.sourceTargetMapping,
          targetable: sourceTargetMapping?.targetable || state.DataqualityPipelin.sourceTargetMapping.targetable,
          targetLayer: sourceTargetMapping?.targetLayer || state.DataqualityPipelin.sourceTargetMapping.targetLayer,
          targetcolumns: sourceTargetMapping?.targetcolumns || state.DataqualityPipelin.sourceTargetMapping.targetcolumns,
          mappings: sourceTargetMapping?.mappings || state.DataqualityPipelin.sourceTargetMapping.mappings,
        },
        sourceTables: sourceTables || state.DataqualityPipelin.sourceTables,
      };
    },
    setMermaidData(state, action) {
      state.dataModal.mermaidScript = action.payload;
    },
    setDataModalSchemaData(state, action) {
      state.dataModal.schemaData = action.payload;
    },
    setDataModelRawData(state, action) {
      state.dataModal.rawData = action.payload;
    },
    setDataModalData(state, action) {
      state.dataModal.dataModalData = action.payload;
    },
    renderdataModel(state, action) {
      state.dataModal.renderdataModel = action.payload;
    },
    setErView(state,action) {
      state.dataModal.ErView = action?.payload;
  },
    setIsModifying(state,action) {
      state.dataModal.isModifying = action?.payload;
  },
  
    setSelectedSchema(state, action) {
      state.dataModal.selectedSchema = action.payload;
    },
    updateMermaidScript(state, action) {
      state.dataModal.mermaidScript = action.payload;
    },
    updateTargetLayer(state, action) {
      state.DataqualityPipelin.sourceTargetMapping.targetLayer = action.payload;
    },
    updateTargetTable(state, action) {
      state.DataqualityPipelin.sourceTargetMapping.targetable = action.payload;
    },
    updateTargetColumns(state, action) {
      state.DataqualityPipelin.sourceTargetMapping.targetcolumns = action.payload;
    },
    updateMappings(state, action) {
      state.DataqualityPipelin.sourceTargetMapping.mappings = action.payload;
    },
    updateDataModelTable(state, action) {
      state.dataModelTable = action.payload;
    },
    updateMermaidScriptInConfig(state, action) {
      state.dataModelConfiguration.mermaidScript = action.payload;
    },
    updateTableInConfig(state, action) {
      state.dataModelConfiguration.table = action.payload;
    },
  },
});
 
export const {
  ADDGeneralSetting,
  setProject,
  // getSourceData,
  GETSourceData,
  // activateSource
  storeActivatedSource,
  // getTargetData,
  GETTargetData,
  // activateTarget,
  storeActivatedTarget,
  getRunningPipeline,
  setDataLakeSetup,
  resetDataLake,
  createNewPipelinetransformation,
  setDeDuplication,
  setPipelineTab,
  setPipelineTable,
  // setDataQualityGeneralSettings,
  addGeneralSettingsDQ,
  updateFilters,
  // updateFillNullValues,
  updateFillNullvalues,
  updateStandardization,
  // updateSourceTable,
  updateSourceTables,
  // updateDataLakeTables,
  updateDatalakeTables,
  // setResetDisabled,
  updateRelation,
  updateBothColumns,
  updateTableOptions,
  updateColumnOptions,
  // updateJoinedColumn,
  updateJoinedColumns,
  addJoinedColumn,
  updateExpression,
  setExpression,
  updateDataQualityPipeline,
  setMermaidData,
  updateMermaidScript,
  updateTargetLayer,
  updateTargetTable,
  setResetDisabled,
  updateTargetColumns,
  updateMappings,
  updateDataModelTable,
  updateMermaidScriptInConfig,
  updateTableInConfig,
  setDataModalSchemaData,
  setDataModelRawData,
  setDataModalData,
  setSelectedSchema,
  renderdataModel,
  setErView,
  setIsModifying,
} = projectSlice.actions;
 
export default projectSlice.reducer;